import { GetHashtagResponse } from "./getResponse"
import { httpGet } from "../../../libs/http/httpGet"
import { HashtagGetInputModel } from "./GetInputModel"

/** ハッシュタグ一覧 */
export const getHashTags = async (): Promise<GetHashtagResponse> => {
  return httpGet<GetHashtagResponse>("/v1/hashtag", new HashtagGetInputModel())
}
